import { useExtendState } from 'helpers/use_extend_state';
import useOnMount from 'helpers/use_on_mount';
import { useAngularService } from './get_angular_service';

interface UsePageSettingsProps {
  page: string;
  defaultValue: any;
  withMeta?: boolean;
}

export const usePageSettings = ({ page, defaultValue, withMeta }: UsePageSettingsProps) => {
  const PageSettingsService = useAngularService('PageSettingsService');

  const [pageSettings, _extendPageSettings, _setPageSettings] = useExtendState<any>(null);

  const getPageSettings = () => {
    PageSettingsService.load(page, { withMeta }).then((settings) => {
      _setPageSettings({ ...defaultValue, ...settings });
    });
  };

  const savePageSettings = (settings) => {
    return PageSettingsService.saveSettings(page, settings, { skipReload: true });
  };

  useOnMount(() => {
    getPageSettings();
  });

  const setPageSettings = (data) => {
    _extendPageSettings(data);
    return savePageSettings(data);
  };

  return {
    pageSettings,
    setPageSettings,
  };
};
